import { render, staticRenderFns } from "./UTag.vue?vue&type=template&id=3cae7b2a&scoped=true"
import script from "./UTag.vue?vue&type=script&lang=js"
export * from "./UTag.vue?vue&type=script&lang=js"
import style0 from "./UTag.vue?vue&type=style&index=0&id=3cae7b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cae7b2a",
  null
  
)

export default component.exports